// extracted by mini-css-extract-plugin
module.exports =  {"skeleton-input":"SkeletonInput-module__skeleton-input___GOFCM","skeleton-input__label":"SkeletonInput-module__skeleton-input__label___HIBOa"};